import { Scoring } from '@/modules/score-set/types';
import { State } from '@/store';

enum scoring {
  unscorable,
  scoring,
  review,
  rejected,
  approved
}

const logicOptions = {
  [Scoring.scoring]: [scoring.unscorable, scoring.review],
  [Scoring.review]: [scoring.approved, scoring.rejected, scoring.scoring],
  [Scoring.unscorable]: [scoring.scoring],
  [Scoring.rejected]: [],
  [Scoring.approved]: []
};
export const getCurrentStep = (rootState: State) => () => {
  const scoreSet = rootState.scoreSet?.scoreSet.data?.status;
  return scoreSet !== undefined ? scoreSet : undefined;
};

export const stepOptions = () => (payload: Scoring) => logicOptions[payload];
